export default __webpack_public_path__ + "static/media/pic3.89b83151.jpg";